/* eslint react/no-multi-comp: 0 */
import React from 'react';
import {BrowserRouter, Route, Routes, useLocation} from 'react-router-dom';
import StoryboardAppContainer from 'storyboard/containers/storyboard-app-container';
import StoryboardChapterContainer from 'storyboard/containers/storyboard-chapter-container';

const StoryboardAppContainerWithLocation = (props) => {
  const location = useLocation();
  return <StoryboardAppContainer {...props} location={location} />;
};

const StoryboardChapterContainerWithLocation = (props) => {
  const location = useLocation();
  return <StoryboardChapterContainer {...props} location={location} />;
};

export const StoryboardRouter = () => (
  <div
    style={{
      height: '100%',
      width: '100%',
    }}>
    <BrowserRouter>
      <Routes>
        <Route
          element={<StoryboardAppContainerWithLocation />}
          exact={true}
          path={window.location.pathname}
        />
        <Route
          element={<StoryboardChapterContainerWithLocation />}
          exact={true}
          path={'/:chapterId'}
        />
      </Routes>
    </BrowserRouter>
  </div>
);
